import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  bulkWizardContainer: {
    height: ({ step }) => (step === 3 ? '100%' : 'unset'),
  },
}));

export default useStyles;
